import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CrudList from "@/components/CrudList";
import { PageHeader, Section, Empty } from "@/components/Shared";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Assets() {
  const [tab, setTab] = useState("assets");
  const [sites, setSites] = useState([]);
  const [assets, setAssets] = useState([]);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/sites").then((r) => setSites(r.data));
    api.get("/assets").then((r) => setAssets(r.data));
    api.get("/hmkm").then((r) => setLogs(r.data));
  }, [tab]);

  return (
    <div>
      <PageHeader title="Aset Alat Berat & HM/KM" subtitle="Excavator, dump truck, dozer + log operasional" testId="assets-header" />
      <Section>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="bg-neutral-900 border border-neutral-800 rounded-none h-auto">
            <TabsTrigger data-testid="tab-assets" value="assets" className="rounded-none data-[state=active]:bg-[#FF6600] data-[state=active]:text-black font-mono text-xs uppercase">Aset</TabsTrigger>
            <TabsTrigger data-testid="tab-hmkm" value="hmkm" className="rounded-none data-[state=active]:bg-[#FF6600] data-[state=active]:text-black font-mono text-xs uppercase">Log HM/KM</TabsTrigger>
          </TabsList>
          <TabsContent value="assets" className="mt-4">
            <CrudList
              title="" subtitle="" endpoint="/assets" exportModule="assets"
              columns={[
                { key: "code", label: "Kode" },
                { key: "name", label: "Nama" },
                { key: "category", label: "Kategori" },
                { key: "status", label: "Status" },
                { key: "hm", label: "HM" },
                { key: "km", label: "KM" },
              ]}
              fields={[
                { key: "code", label: "Kode Aset", required: true, placeholder: "EXC-001" },
                { key: "name", label: "Nama", required: true, placeholder: "Excavator PC200" },
                { key: "category", label: "Kategori", type: "select", options: [
                  { value: "excavator", label: "Excavator" },
                  { value: "dump_truck", label: "Dump Truck" },
                  { value: "dozer", label: "Dozer" },
                  { value: "grader", label: "Grader" },
                  { value: "loader", label: "Loader" },
                  { value: "lainnya", label: "Lainnya" },
                ], required: true },
                { key: "status", label: "Status", type: "select", options: [
                  { value: "active", label: "Aktif" },
                  { value: "maintenance", label: "Maintenance" },
                  { value: "idle", label: "Idle" },
                ] },
                { key: "hm", label: "Hour Meter Awal", type: "number", placeholder: "0" },
                { key: "km", label: "Kilometer Awal", type: "number", placeholder: "0" },
                { key: "site_id", label: "Site", type: "select", options: sites.map((s) => ({ value: s.id, label: s.name })), wide: true },
              ]}
            />
          </TabsContent>
          <TabsContent value="hmkm" className="mt-4">
            <CrudList
              title="" subtitle="" endpoint="/hmkm" exportModule="hmkm" auditEntity="hmkm_logs"
              columns={[
                { key: "date", label: "Tanggal" },
                { key: "asset_id", label: "Aset", render: (r) => assets.find((a) => a.id === r.asset_id)?.code || r.asset_id },
                { key: "hm", label: "HM" },
                { key: "km", label: "KM" },
                { key: "note", label: "Catatan" },
              ]}
              fields={[
                { key: "date", label: "Tanggal", type: "date", required: true },
                { key: "asset_id", label: "Aset", type: "select", options: assets.map((a) => ({ value: a.id, label: `${a.code} - ${a.name}` })), required: true },
                { key: "hm", label: "Hour Meter", type: "number", required: true },
                { key: "km", label: "Kilometer", type: "number", required: true },
                { key: "note", label: "Catatan", wide: true },
        { key: "photo_url", label: "Foto Odometer/HM", type: "photo", kind: "hmkm", wide: true },
              ]}
            />
          </TabsContent>
        </Tabs>
      </Section>
    </div>
  );
}
